import './App.css'
import { Banner } from './components/Banner'
import 'bootstrap/dist/css/bootstrap.min.css'
import { NavBar } from './components/NavBar.js'
import { useEffect } from "react"
import { initMetaPixel } from "./utils/metaPixel"
import 'react-multi-carousel/lib/styles.css'
import { Projects } from './components/Projects.js'
import { Test } from './components/Test.js'

function App() {
  useEffect(() => {
    initMetaPixel() // Como seu código já tem o ID fixo, não precisa passar argumento
  }, [])

  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Projects />
      <Test />
    </div >
  )
}

export default App
